import type { HouseholdOnboardingPrimaryCta } from 'src/features/advisor-book-onboarding/constants/household-onboarding-status-copy';
import { ADVISOR_BOOK_ONBOARDING_ROUTES } from 'src/features/advisor-book-onboarding/constants/routes';

export type HouseholdOnboardingPrimaryCtaKind = NonNullable<HouseholdOnboardingPrimaryCta>['kind'];

type PrimaryHrefParams = {
  readonly kind: HouseholdOnboardingPrimaryCtaKind | undefined;
  readonly householdPublicId: string | null;
};

export function householdOnboardingPrimaryHrefFor({ kind, householdPublicId }: PrimaryHrefParams) {
  switch (kind) {
    case 'confirm_accounts':
      return householdPublicId === null
        ? null
        : ADVISOR_BOOK_ONBOARDING_ROUTES.eciAccountOnboardingFlow(householdPublicId, 'confirm-accounts');
    case 'send_onboarding':
      return householdPublicId === null
        ? null
        : ADVISOR_BOOK_ONBOARDING_ROUTES.eciAccountOnboardingFlow(householdPublicId, 'client-email');
    case 'fix_contact_info':
    case 'dismiss':
    case undefined:
      return null;
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}

export function householdOnboardingPrimaryCtaLabel(kind: HouseholdOnboardingPrimaryCtaKind) {
  switch (kind) {
    case 'confirm_accounts':
      return 'Confirm accounts';
    case 'send_onboarding':
      return 'Send onboarding';
    case 'fix_contact_info':
      return 'Fix contact info';
    case 'dismiss':
      return 'Dismiss';
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}
